import { render, staticRenderFns } from "./PrijavaKvaraComponent.vue?vue&type=template&id=1887b7b3&scoped=true&"
import script from "./PrijavaKvaraComponent.vue?vue&type=script&lang=ts&"
export * from "./PrijavaKvaraComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887b7b3",
  null
  
)

export default component.exports